import { render, staticRenderFns } from "./NewsHome.vue?vue&type=template&id=fd20a5ae&"
import script from "./NewsHome.vue?vue&type=script&lang=js&"
export * from "./NewsHome.vue?vue&type=script&lang=js&"
import style0 from "./NewsHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports